/* 
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview Utilitaires pour le html, extraction de données
 */
(function($g, $) {
    "use strict";
    
    function encodeEntities(rawStr) {
        var encodedStr = rawStr.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
            return '&#' + i.charCodeAt(0) + ';';
        });
        return encodedStr;
    }

    /**
     * Convert xml content to html string
     * Required to fix chrome undefined innerHTML
     * @param node	DOMElement	
     */
    $g.html = function (node) {
        var r = "";
        if (!node.childNodes) {
            node = node[0];
        }
        node.childNodes.forEach(function(e) {
            switch (e.nodeType) {
                case 3://text
                case 4://cdata
                    r += encodeEntities(e.data || e.textContent || e.text);
                    break;
                case 1://element
                    r += "<" + e.tagName;
                    $.each(e.attributes, function (k, v) {
                        r += " " + v.nodeName + "=\"" + encodeEntities(v.nodeValue) + "\"";
                    });
                    var ct = $g.html(e);
                    if (ct !== "") {
                        r += ">" + ct + "</" + e.tagName + ">";
                    } else {
                        r += " />";
                    }
                    break;
            }
        });
        return r;
    };

    /**
     * Extract attributes as object
     * @param node DOMElement	node with parameters to extrac 
     */
    $g.attr = function (node) {
        var r = {};
        $.each(node.attributes, function (k, v) {
            r[v.nodeName] = v.nodeValue;
        });
        return r;
    };
    
})(PVPGEngine, jQuery);